import { config } from "@config/config";
import { ContentTagCode } from "@config/tag-code";
import { QuestionsDocument, QuestionsQuery, QuestionsQueryVariables, useQuestionsQuery } from "@gql-schema";
import { FaqPageSection } from "@shared/components/faqs-section/faq-page-section";
import { Helmet } from "@shared/components/helmet/helmet";
import { NavBar } from "@shared/components/navbar/navbar";
import { addApolloState, initializeApollo } from "@shared/lib/Apollo";
import { basicStaticProps } from "@shared/utils/basic-static-props";
import { useLocale } from "@translations/locale-context";
import { Footer } from "@ui/components/footer/footer";
import { GetStaticProps, NextPage } from "next";
import { useTranslation } from "next-i18next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import React from "react";

export const Page: NextPage = () => {
    const { t } = useTranslation();
    const locale = useLocale();
    const { data } = useQuestionsQuery({
        variables: {
            tagCodes: [locale === "cs" ? ContentTagCode.Czech : ContentTagCode.English],
        },
    });

    if (!data) {
        return null;
    }

    return (
        <>
            <Helmet
                canonicalUrl={config.FRONTEND_URL + (locale === "en" ? "/en/faq" : "/caste-otazky")}
                metaTagData={{
                    metaDescription: t("helmet.faq.description"),
                    metaTitle: t("helmet.faq.title"),
                }}
                title={t("helmet.faq.title")}
            />
            <NavBar />
            <main>
                <FaqPageSection items={data.questions} />
            </main>
            <Footer />
        </>
    );
};

export const getStaticProps: GetStaticProps = basicStaticProps(async ({ locale }) => {
    const apolloClient = initializeApollo(null);
    await apolloClient.query<QuestionsQuery, QuestionsQueryVariables>({
        query: QuestionsDocument,
        variables: {
            tagCodes: [locale === "cs" ? ContentTagCode.Czech : ContentTagCode.English],
        },
    });

    return addApolloState(apolloClient, {
        props: {
            ...(await serverSideTranslations(locale ?? "cs", ["common"])),
        },
        revalidate: 10,
    });
});
